import axios from "axios";

export default {
    namespaced: true,

    state: () => ({
        availableSurveys: [],
        jobLevels: [],
        settings: [],
        submitResult: null,
        passings: [],
        passingsTotal: null,
        passingsPagination: {
            page: 1,
            per_page: 20,
            total: 0,
            last_page: 1,
        },
        passing: null,
        passingsListState: {
            currentPage: null,
            sortField: null,
            sortOrder: null,
            type: null,
            user_id: null,
        },
    }),

    mutations: {
        setAvailableSurveys(state, data) {
            state.availableSurveys = data;
        },
        setJobLevels(state, data) {
            state.jobLevels = data;
        },
        setSettings(state, data) {
            state.settings = data;
        },
        updateSetting(state, data) {
            const index = state.settings.findIndex((item) => item.survey?.id === data.survey?.id);

            if (index >= 0) {
                state.settings.splice(index, 1, data);
                return;
            }

            state.settings.push(data);
        },
        setSubmitResult(state, data) {
            state.submitResult = data;
        },
        setPassings(state, data) {
            state.passings = data.data ?? data ?? [];
            state.passingsPagination = {
                page: data.pagination?.page ?? 1,
                per_page: data.pagination?.per_page ?? 20,
                total: data.pagination?.total ?? data.meta?.total ?? data.total ?? 0,
                last_page: data.pagination?.last_page ?? 1,
            };
            state.passingsTotal = state.passingsPagination.total;
        },
        clearPassings(state) {
            state.passings = [];
            state.passingsTotal = null;
            state.passingsPagination = {
                page: 1,
                per_page: 20,
                total: 0,
                last_page: 1,
            };
        },
        setPassing(state, data) {
            state.passing = data.data ?? data;
        },
        clearPassing(state) {
            state.passing = null;
        },
        setPassingsListState(state, payload) {
            state.passingsListState = {
                ...state.passingsListState,
                ...payload,
            };
        },
        clearPassingsListState(state) {
            state.passingsListState = {
                currentPage: null,
                sortField: null,
                sortOrder: null,
                type: null,
                user_id: null,
            };
        },
    },

    actions: {
        async getAvailable({ commit }) {
            return await axios.get('/periodic_surveys/available').then(({ data }) => {
                commit("setAvailableSurveys", data);

                return data;
            })
        },
        async getJobLevels({ commit }) {
            return await axios.get('/periodic_surveys/job_levels').then(({ data }) => {
                commit("setJobLevels", data);

                return data;
            })
        },
        async setPassingJobLevel(_, data) {
            return await axios.post('/periodic_surveys/passing/job_level', data).then(({ data }) => data)
        },
        async getSettings({ commit }) {
            return await axios.get('/periodic_surveys/settings').then(({ data }) => {
                commit("setSettings", data);

                return data;
            })
        },
        async setSettings({ commit }, data) {
            return await axios.post('/periodic_surveys/settings', data).then(({ data }) => {
                commit("updateSetting", data);

                return data;
            })
        },
        async submit({ commit }, data) {
            return await axios.post('/periodic_surveys/submit', data).then(({ data }) => {
                commit("setSubmitResult", data);

                return data;
            })
        },
        async createNotification(_, data) {
            return await axios.post('/periodic_surveys/notification', data).then(({ data }) => data)
        },
        async getPassings({ commit }, params) {
            return await axios.get('/periodic_surveys/passings', { params }).then(({ data }) => {
                commit("setPassings", data);

                return data;
            })
        },
        async getPassing({ commit }, code) {
            return await axios.get(`/periodic_surveys/passings/${code}`).then(({ data }) => {
                commit("setPassing", data);

                return data;
            })
        },
        clearPassings({ commit }) {
            commit("clearPassings");
        },
        clearPassing({ commit }) {
            commit("clearPassing");
        },
    }
}
